export const GameTypeStratego = "stratego";
export const GameTypeMandala = "mandala";
export const GameTypeRepeat = "repeat";
export const GameTypeFindPair = "find-pair";
export const GameTypeBarleyBreak = "barley-break";
export const GameTypePuzzle = "puzzle";
export const GameTypeMahjong = "mahjong";
export const GameTypeMatchThree = "match-three";
export const GameTypeThreeBoom = "three-boom";
export const GameTypeTetris = "tetris";
export const GameTypeXonix = "xonix";
export const GameTypeCrossing = "crossing";
export const GameTypeColoring = "coloring";
export const GameTypeFindDiff = "find-diff";
export const GameTypePokerMachine = "poker-machine";
export const GameTypeDropDown = "drop-down";
export const GameTypeFlyUp = "fly-up";
export const GameTypeZuma = "zuma";
export const GameTypeIslands = "islands";
export const GameTypeBoulderDash = "boulder-dash";

export type GameTypes =
  | typeof GameTypeStratego
  | typeof GameTypeMandala
  | typeof GameTypeRepeat
  | typeof GameTypeFindPair;
